import { render, staticRenderFns } from "./ApiTokensPage.vue?vue&type=template&id=1c76638e"
import script from "./ApiTokensPage.vue?vue&type=script&lang=js"
export * from "./ApiTokensPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports